import { render, staticRenderFns } from "./SmartFaqItem.vue?vue&type=template&id=8e171dea"
import script from "./SmartFaqItem.vue?vue&type=script&lang=js"
export * from "./SmartFaqItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports